import { createSelector } from 'reselect';
import { PASSAGE } from '../constants/assessmentItemType';

export const getIsMazeDataFetched = (state) => state.isDataFetched;

export const getMazeParagraphs = (state, pageType = PASSAGE) => state[pageType].paragraphs;

export const getMazeQuestionItems = (state, pageType = PASSAGE) => state[pageType].items;

export const getMazeReadyForNextScript = (state) => state.isReadyScriptPlayed;

export const getMazeTitle = (state, pageType = PASSAGE) => state[pageType].title;

export const getMazeCorrectResponse = (state, pageType, questionId) => {
    const questions = getMazeQuestionItems(state, pageType);
    const questionById = questions.find((question) => question.id === questionId);
    return questionById && questionById.correctResponse;
};

export const getIsMazeFirstAttemptMade = (state) => state.isFirstAttemptMade;

export const getLastMazeQuestion = createSelector(
    getMazeQuestionItems,
    (questions) => questions[questions.length - 1],
);

export const getMazeSelectedResponses = (state) => state.selectedResponses;

export const getMazeFormId = (state) => state.formId;

export const getMazeScreenMode = (state) => state.screenMode;

export const isMazeUntimed = (state) => state.isMazeUntimed;
